const piiBlockList = new Set<string>(['email', '_hse', 'password'])

const redactPii = <K extends string, T>(key: K, value: T): T | string => {
  if (piiBlockList.has(key)) {
    return '[REDACTED]'
  } else if (typeof value === 'string') {
    return value.replaceAll(/(\\?"email\\?":\s*\\?")([^"\\]+)(\\?")/giu, '$1[REDACTED]$3')
  }
  return value
}

export const redactPiiFromObj = <O>(baseObj: O) => {
  if (typeof baseObj !== 'object' || !baseObj) {
    return baseObj
  }

  return Object.keys(baseObj).reduce(
    (obj: Record<string, unknown>, key) => {
      obj[key] = redactPii(key, (baseObj as Record<string, unknown>)[key])
      return obj
    },
    {} as Record<string, unknown>,
  )
}

export const redactPiiFromUrl = (url: string): string => {
  const urlObj = new URL(url)
  const params = new URLSearchParams(urlObj.search)
  for (const [key, value] of params.entries()) {
    params.set(key, redactPii(key, value))
  }

  return `${urlObj.pathname}?${params}`
}
